var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestionCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1233",
    "data-name": "Group 1233",
    width: 24.49,
    height: 24.49,
    viewBox: "0 0 24.49 24.49",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "informacion_4_",
    "data-name": "informacion (4)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 1.196,
    cy: 1.196,
    r: 1.196,
    transform: "translate(11.049 16.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M12.245,0A12.245,12.245,0,1,0,24.489,12.245,12.238,12.238,0,0,0,12.245,0Zm0,22.576A10.332,10.332,0,1,1,22.576,12.245,10.326,10.326,0,0,1,12.245,22.576Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M179.826,128.5A3.831,3.831,0,0,0,176,132.327a.957.957,0,0,0,1.913,0,1.913,1.913,0,1,1,1.913,1.913.957.957,0,0,0-.957.957v2.392a.957.957,0,1,0,1.913,0v-1.556a3.827,3.827,0,0,0-.957-7.532Z",
    transform: "translate(-167.582 -122.354)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question_circle.3113ec9d.svg";
export { ForwardRef as ReactComponent };